import { css } from '@emotion/react';
import { Colors } from '../Colors';
import { Variables } from '../Variables';

export const shimmer = css`
  background-color: ${Colors.ut.input};
  border-radius: ${Variables.shimmerRadius};
  animation: shimme 1s ease-in-out infinite alternate;

  @keyframes shimme {
    to {
      opacity: 0.5;
    }
  }
`;
